import React from "react";
import { Tags } from "./Tags";
import { newsDisplayIsSummaryType, newsItemType, newsPictureType } from "../../../common/types/search/news";

interface ThumbnailProps {
	summary: newsDisplayIsSummaryType;
	picture: newsPictureType;
	title: string;
	url: string;
	item: newsItemType;
}

export function Thumbnail({
	summary,
	picture,
	title,
	url,
	item,
}: ThumbnailProps) {
	const thumb = summary ? (
		<div className="post__img">
			<a href={url} aria-hidden="true" tabIndex={-1}>
				<img src={picture.get("uri")} alt={title} />
			</a>
			<Tags item={item} />
		</div>
	) : (
		<Tags item={item} />
	);

	return <div className="post__thumb">{thumb}</div>;
}
